module.exports = __webpack_public_path__ + "static/logo-dark-f79ca09414dd37dbf74df7ec8ead2e81.svg";